"use client";
import Image from "next/image";

interface ProductCardBannersProps {
  banners: string[];
}

const ProductCardBanners = ({ banners }: ProductCardBannersProps) => {
  if (!banners || banners.length === 0) return null;

  return (
    <div className="absolute top-1 left-1 sm:top-2 sm:left-2 z-10 flex flex-col gap-0.5 sm:gap-1">
      {banners.map((banner, index) => (
        <div
          key={index}
          className="relative w-10 h-10 sm:w-14 sm:h-14 rounded overflow-hidden"
        >
          <Image
            src={banner}
            alt={`Product banner ${index + 1}`}
            fill
            className="object-contain"
            sizes="(max-width: 640px) 40px, 56px"
          />
        </div>
      ))}
    </div>
  );
};

export default ProductCardBanners;
